import charlesFelt from './images/charlesFelt.png';
import charlestech from './images/charlestech.png';
import metcopo from './images/metcopo.png';
import stepTile from './images/stepTile.png';
import cameroon from './images/cameroon_2.png'

const productInfoData = [
  /*
  {
    id: 1,
    name: 'Thermal Insulation Roof Sheets',
    Image: thermal_insulation,
    description: `Designed to reduce heat transfer, these sheets provide superior thermal efficiency, 
    keeping buildings cooler in hot climates. They are durable, lightweight, and easy to install, 
    making them a cost-effective solution for energy savings. Ideal for both residential and commercial applications.`,
  },
  {
    id: 2,
    name: 'Stone Coated Roof Sheets',
    Image: stone_coated,
    description: `These premium roofing sheets combine the strength of steel with the elegance of natural stone. 
    Resistant to weather and corrosion, they offer long-lasting protection with a sophisticated finish. 
    Perfect for homeowners seeking durability without compromising on style.`,
  },
  {
    id: 3,
    name: 'Regular Roof Sheets',
    Image: regularRoofSheets,
    description: `Affordable and reliable, these roofing sheets are a versatile choice for various construction needs. 
    With a straightforward design and robust build, they provide dependable shelter. An excellent option for basic roofing projects.`,
  },
  */
  {
    id: 4,
    name: 'Charlestech Roof Tiles Sheets',
    Image: charlestech,
    description: `Locally manufactured in Nigeria, these tiles blend steel stone-coated beauty with exceptional practicality. 
    Lightweight, colorfast, and resistant to algae, they ensure long-lasting appeal. A sustainable roofing choice supporting the local economy and environment.`,
  },
  {
    id: 5,
    name: 'Cameroon Roof Sheets',
    Image: cameroon,
    description: `These high-quality roofing sheets are celebrated for their robustness and weather resistance. 
    Suitable for diverse climates, they offer excellent durability and an attractive finish. A trusted choice for homes and businesses across regions.`,
  },
  {
    id: 6,
    name: 'Steptile Roof Sheets',
    Image: stepTile,
    description: `Crafted for both function and style, these sheets feature a step-tile design that mimics traditional tiles. 
    Offering enhanced aesthetics with modern durability, they are ideal for homes seeking a polished and unique look. Easy to install and maintain.`,
  },
  {
    id: 7,
    name: 'Metcopo Roof Sheets',
    Image: metcopo,
    description: `Known for their wavy design, these sheets provide a sleek, contemporary appearance.
    Strong and weather-resistant, they are a popular choice for residential and commercial roofing. Their lightweight nature ensures easier handling and installation.`,
  },
  {
    id: 8,
    name: 'Charles Felt Membrane',
    Image: charlesFelt,
    description: `A reliable underlayment solution locally manufactured in Nigeria, 
    this felt membrane offers superior waterproofing and protection against leaks. 
    Durable and flexible, it enhances the longevity of the roofing system. Essential for safeguarding roofs in harsh weather conditions.`,
  }  
];
export default productInfoData;